const pageNameKey = "rolesDescriptionsPopover";

export const rolesDescriptionsPopoverEn = {
  [pageNameKey]: {
    rolesDescriptionsTitle: "Roles Descriptions",
  },
};

export const rolesDescriptionsPopoverPtBr = {
  [pageNameKey]: {
    rolesDescriptionsTitle: "Descrições de funções",
  },
};

export const rolesDescriptionsPopoverDe = {
  [pageNameKey]: {
    rolesDescriptionsTitle: "Rollenbeschreibungen",
  },
};

export const rolesDescriptionsPopoverZhHans = {
  [pageNameKey]: {
    rolesDescriptionsTitle: "角色描述",
  },
};

export const rolesDescriptionsPopoverIt = {
  [pageNameKey]: {
    rolesDescriptionsTitle: "Descrizioni dei ruoli",
  },
};

export const rolesDescriptionsPopoverEs = {
  [pageNameKey]: {
    rolesDescriptionsTitle: "Descripción de roles",
  },
};

export const rolesDescriptionsPopoverNl = {
  [pageNameKey]: {
    rolesDescriptionsTitle: "Rolbeschrijvingen",
  },
};

export const rolesDescriptionsPopoverTr = {
  [pageNameKey]: {
    rolesDescriptionsTitle: "Roller Açıklamaları",
  },
};
